const shipToSeal = {
  shiptoNo: 'shipto编号',
  shiptoName: 'shipto名称',
  description: '描述说明',
  sealUrl: '印章图片',
  attachmentUrl: '附件',
  msg: {}
};
export default shipToSeal;



// WEBPACK FOOTER //
// ./src/page/md/shipToSeal/lang/shipToSeal.zh.js